import React, { useEffect } from "react";
import Title from "../components/Title";
import SecondaryTitle from "../components/SecondaryTitle";
import Subtitle from "../components/Subtitle";
import Dropdown from "../components/Dropdown";
import Bang from "../components/Bang";

import prizeFreeBlock from "../assets/icons/your-prize-free-block.svg";
import prizeFreeInner from "../assets/icons/your-prize-free-inner.png";
import discountBlock from "../assets/icons/your-prize-discount-block.svg";
import discountInner from "../assets/icons/your-prize-discount-inner.png";
import Button from "../components/Button";

import decor6 from "../assets/images/decors/decor6.png";
import decor7 from "../assets/images/decors/decor7.png";
import decor8 from "../assets/images/decors/decor8.png";
import decor9 from "../assets/images/decors/decor9.png";
import decor10 from "../assets/images/decors/decor10.png";
import decor11 from "../assets/images/decors/decor11.png";
import RendersDropdown from "../components/RendersDropdown";

const ExchangeScreen = ({ exchangeType, setIsComplete }) => {
  const [exchangeList, setExchangeList] = React.useState([]);
  const [exchangeBankList, setExchangeBankList] = React.useState([]);
  const [exchangeRenderList, setExchangeRenderList] = React.useState([]);
  const [selectedBank, setSelectedBank] = React.useState(null);
  const [selectedRender, setSelectedRender] = React.useState(null);
  const [openDropdown, setOpenDropdown] = React.useState(null);

  const getExchangeList = async () => {
    const jwtToken = window.sessionStorage.getItem("jwtToken");
    try {
      const response = await fetch("https://roulette.sp-hub.org/api/exchange/list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${jwtToken}`,
        },
      });
      const data = await response.json();

      if (data) {
        setExchangeList(data);
        setExchangeBankList(
          data.map((item) => ({
            name: item.bank,
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const searchByBank = (searchTerm, data) => {
    if (!searchTerm) {
      return [];
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    const result = data
      .filter((item) => item.bank.toLowerCase().includes(lowerSearchTerm))
      .map((item) => item.renders);

    return result;
  };

  const handleExchange = async () => {
    console.log(selectedRender);
    const jwtToken = window.sessionStorage.getItem("jwtToken");
    try {
      const response = await fetch("https://roulette.sp-hub.org/api/exchange/complete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${jwtToken}`,
        },
        body: JSON.stringify({
          renderId: selectedRender.id,
          type: selectedRender.type,
        }),
      });
      const data = await response.json();
      if (data.result) {
        setIsComplete(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getExchangeList();
  }, []);

  useEffect(() => {
    setExchangeRenderList(...searchByBank(selectedBank?.name, exchangeList));
  }, [selectedBank, exchangeList, setExchangeRenderList]);

  return (
    <main className="relative z-10 bg-main flex items-center justify-center bg-cover bg-center min-h-screen w-full overflow-hidden">
      <div className="absolute z-[-1] -left-32 top-16 animate-moveX animate-moveY">
        <div className="absolute h-44 w-44 bg-blue opacity-10 blur-3xl rounded-full z-[-1] animate-pulse"></div>

        <img src={decor6} alt="Процент" />
      </div>
      <div className="absolute z-[-1] -right-4 -bottom-2 animate-moveX animate-moveY">
        <img src={decor10} alt="Процент" />
      </div>
      <div className="absolute z-[-1] left-24 top-112 animate-moveX animate-moveY">
        <img src={decor7} alt="Процент" />
      </div>
      <div className="absolute z-[-1] -left-48 -bottom-4 animate-moveX animate-moveY">
        <img src={decor8} alt="Процент" />
      </div>
      <div className="absolute z-[-1] -right-[28rem] -top-24 animate-moveX animate-moveY">
        <div className="absolute h-44 w-44  top-2/3 left-80 bg-green opacity-5 blur-3xl rounded-full z-[-1] animate-pulse"></div>

        <img src={decor9} alt="Процент" />
      </div>
      <div className="absolute z-[-1] right-52 top-52 animate-moveX animate-moveY">
        <img src={decor11} alt="Процент" />
      </div>
      <div className="relative container mx-[5px] mobile:py-8 small:py-8 desktop:py-0">
        <div className="grid grid-cols-1 desktop:grid-cols-2 gap-4">
          <section className="text-center rounded-lg bg-gradient-dark-green border-darkGreen border-4">
            <div className="mobile:mb-6 desktop:mb-16">
              <Bang />
            </div>
            <div className="flex justify-center mb-9 text-center">
              <Title text="Твой приз" />
            </div>
            <div className="flex justify-center">
              <div className="absolute h-48 w-48 bg-green opacity-50 blur-3xl rounded-full z-[1] animate-ping"></div>

              {exchangeType !== "free" ? (
                <div className="relative mb-14">
                  <img className="w-[200px] h-[200px] z-[2]" src={discountBlock} alt="" />
                  <img
                    className="w-[157px] left-[50%] translate-x-[-50%] absolute top-20"
                    src={discountInner}
                    alt=""
                  />
                </div>
              ) : (
                <div className="relative">
                  <img className="mb-14 w-[200px] h-[200px] z-[2]" src={prizeFreeBlock} alt="" />
                  <img className="w-[200px] h-[200px] absolute top-5" src={prizeFreeInner} alt="" />
                </div>
              )}
            </div>
            <div className="flex justify-center mb-16">
              <Subtitle text="Обменяй его на отрисовку желаемого банка" />
            </div>
          </section>
          {/* SVG arrows */}
          <div className="absolute flex w-full h-full justify-center items-center">
            <div className="absolute flex justify-center items-center bg-gradient-green w-20 h-20 rounded-full">
              <svg
                className="absolute"
                width="38"
                height="42"
                viewBox="0 0 38 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 22.9999L3 31M3 31L11 39M3 31L35.0001 31M27.0001 18.9999L35.0001 10.9999M35.0001 10.9999L27.0001 2.99987M35.0001 10.9999L3 10.9999"
                  stroke="white"
                  stroke-width="5.00002"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          {/* Второй блок */}

          <section className="flex flex-col justify-center p-10 rounded-lg bg-gradient-dark-green border-4 border-darkGreen ">
            <div className="relative flex flex-col w-full text-left mobile:mb-3 desktop:mb-3">
              <div className="flex text-start gap-6 items-center mobile:mb-2 small:mg-4 desktop:mb-4">
                <div className="bg-gradient-green h-[41px] w-[41px] rounded-full flex justify-center items-center text-center font-title text-white">
                  1
                </div>
                <SecondaryTitle text="Выбери банк:" />
              </div>
              <div className="flex gap-6">
                <div className="absolute top-12 flex w-[41px] justify-center">
                  <svg
                    width="2"
                    height="71"
                    viewBox="0 0 2 71"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.999919"
                      y1="0.411133"
                      x2="0.999916"
                      y2="70.4111"
                      stroke="#26AB8D"
                      stroke-width="1.33333"
                      stroke-dasharray="4.67 4.67"
                    />
                  </svg>
                </div>
                <div className="w-full pl-[65px]">
                  <Dropdown
                    text="Выбери банк"
                    listMenu={exchangeBankList}
                    selectedItem={selectedBank}
                    setSelectedItem={setSelectedBank}
                    setSelectedRender={setSelectedRender}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    dropdownName="bank"
                  />
                </div>
              </div>
            </div>
            <div className="relative flex flex-col w-full text-left mobile:mb-3 desktop:mb-3">
              <div className="flex text-start gap-6 items-center mobile:mb-2 small:mb-4 desktop:mb-4">
                <div className="bg-gradient-green h-[41px] w-[41px] rounded-full flex justify-center items-center text-center font-title text-white">
                  2
                </div>
                <SecondaryTitle text="Выбери отрисовку:" />
              </div>
              <div className="flex gap-6">
                <div className="absolute top-12 flex w-[41px] justify-center">
                  <svg
                    width="2"
                    height="71"
                    viewBox="0 0 2 71"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.999919"
                      y1="0.411133"
                      x2="0.999916"
                      y2="70.4111"
                      stroke="#26AB8D"
                      stroke-width="1.33333"
                      stroke-dasharray="4.67 4.67"
                    />
                  </svg>
                </div>
                <div className="w-full pl-[65px]">
                  <RendersDropdown
                    text="Выбери отрисовку"
                    selectedItem={selectedRender}
                    setSelectedItem={setSelectedRender}
                    listMenu={exchangeRenderList}
                    disabled={!selectedBank}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    dropdownName="render"
                  />
                </div>
              </div>
            </div>
            <div className="relative flex flex-col w-full text-left mobile:mb-3 desktop:mb-3">
              <div className="flex text-start gap-6 items-center mobile:mb-2 small:mb-5 desktop:mb-5 ">
                <div className="bg-gradient-green h-[41px] w-[41px] rounded-full flex justify-center items-center font-title text-white">
                  3
                </div>
                <SecondaryTitle text="Подтверди обмен:" />
              </div>
              <div className="flex gap-6">
                <div className="min-w-[41px]"></div>
                <div className="max-w-[250px]">
                  <Button
                    onClick={handleExchange}
                    text="Обменять"
                    disabled={!selectedBank || !selectedRender}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default ExchangeScreen;
